import React from 'react';
import '../App.css';
import Notification from './Notification';
import spinner from '../images/spinner.gif';

const pageSize = 10;

export default class NotificationMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {isFetching: false};
  }

  handleScroll(e) {
    if (!e.target) return;
    if ((e.target.clientHeight + e.target.scrollTop) >= e.target.scrollHeight) {
       this.fetchNotifications();
    }
  }

  componentDidMount() {
    if (this.props.app.state.showNotificationMenu) {
      this.fetchNotifications();
    }
  }

  componentWillReceiveProps() {
    if (this.props.app.state.showNotificationMenu && !this.state.fetched) {
      this.fetchNotifications();
    }
    // Iterate through notififications we have loaded and if any are seen: false
    // mark them as seen.
    if (this.state && this.state.notifications && this.props.app.state.showNotificationMenu) {
      let that = this;
      let counter = that.props.app.notificationCounter;
      let notifications = this.state.notifications;
      let updates = false;
      for (let i = 0; i < notifications.length; i++ ) {
        let notf = notifications[i]
        if (notf.seen === 'false' || notf.seen === false) {
          updates = true;
          let notificationId = notf._id['$oid'];
          const uri = `/api/v1/notifications/${notificationId}`;
          const seenParams = {method: 'PUT'};
          try {
            fetch(uri, seenParams).then(d => d.json().then(data => {
              that.props.app.setState({notificationCounter: (counter - 1)});
              notf.seen = true;
              console.log('Marked notification with id: ' + notificationId + ' as seen.');
            }));
          } catch(e) {
            console.log('[Error] marking notification as seen: ' + e);
          }
        }
      }
      if (updates) {
        // There are updates!!!! Set state...
        this.setState({notifications: notifications});
      }
    }
  }

  async fetchNotifications() {
    if (this.state.isFetching) {
      return;
    }
    let url = window.location.protocol + '//' + window.location.host;
    let that = this;
    let nextPage = this.state.nextPage || 1;
    let notifications = this.state.notifications || [];
    // Should only need to do this once. New notifications will come off of the bus...
    // Fetch notifications..
    if (this.state.totalNotifications && notifications.length >= this.state.totalNotifications) {
      return;
    }
    this.setState({isFetching: true});
    const d = await fetch(`/api/v1/notifications?page=${nextPage}&per_page=${pageSize}`);
    d.json().then(data => {
      if (data?.notifications) {
        // We may have received a notification off the bus that we can ignore from the back end..
        for (let i = 0; i < data['notifications'].length; i++) {
          let newn = data['notifications'][i];
          let found = false;
          for (let n = 0; n < notifications.length; n++) {
            if (notifications[n]['_id']['$oid'] === newn._id['$oid']) {
              found = true;
            }
          }
          if (!found) {
            notifications.push(newn);
          }
        }
        let totalNotifications = data['meta']['total_notifications'];
        that.props.app.setState({notificationCounter: data['meta']['total_unseen_notifications']});
        that.setState({
          fetched: true,
          isFetching: false,
          notifications: notifications,
          nextPage: (nextPage + 1),
          lastPage: nextPage,
          totalNotifications: totalNotifications,
        });
      }
    });
  }

  render() {
    let notifications = this.state.notifications || [];
    let notificationComponents = [];
    for (let i = 0; i < notifications.length; i++ ) {
      let notification = <Notification key={notifications[i]['_id']['$oid']} data={notifications[i]} app={this.props.app} />;
      notificationComponents.push(notification);
    }
    return (
      <div className='notificationsMenu' onScroll={(e) => this.handleScroll(e)}  id='notf' style={{display: this.props.app.state.showNotificationMenu ? 'inline-block' : 'none'}}>
        Notificações
        <hr />
        <div className='notificationsMenuInner' id='notf'>
          {notificationComponents.length > 0 ? notificationComponents : ''}
          {this.state.isFetching ? <img src={spinner} style={{height: '40px', marginBottom: '10px', marginLeft: '160px'}} alt='' /> : ''}
        </div>
      </div>
    );
  }
}
